export default "<p>delete-workreport-dialog works!</p>\n"